import { render } from "./Export.vue?vue&type=template&id=45f64741&ts=true"
import script from "./Export.vue?vue&type=script&lang=ts"
export * from "./Export.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/alarm-receiver-frontend/alarm-receiver-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__